import React from 'react';
import { Card, Button, Row, Col } from 'react-bootstrap';
import './WelcomeComponent.css';
import useSettings from '../hooks/useSettings';

const WelcomeComponent = ({ chatStarters, onStarterClick, onCustomPrompt }) => {
  const { getSetting } = useSettings();
  const welcomeContent = getSetting('welcome_content', '');
  return (
    <div className="welcome-component">
        <div className="welcome-header mb-4">
          <Row className="align-items-center">
            <Col md={3}>
              <img src="img/karl-b-gpt.png" alt="Karl B – Your Personal Advocacy Assistant!" className="img-fluid" />
            </Col>
            <Col md={9}>
            {welcomeContent ? (
              <div dangerouslySetInnerHTML={{ __html: welcomeContent }} />
            ) : (
              <><h1>Hello, I'm Karl B!</h1>
              <h2>Your Personal Advocacy Assistant!</h2>
              <p>Let me help you with your advocacy questions and needs.</p></>
            )}
            </Col>
          </Row>
        </div>
        <h5 className="starter-heading">Try asking about:</h5>
        <Row className="starter-grid">
          {chatStarters.map((starter, index) => (
            <Col md={6} key={index} className="mb-3">
              <Card
                className="starter-card h-100"
                role="button"
                tabIndex={0}
                onClick={() => onStarterClick(starter)}
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onStarterClick(starter); } }}
                title={starter}
              >
                <Card.Body className="d-flex flex-column justify-content-center">
                  <div className="starter-text">{starter}</div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
    </div>
  );
};

export default WelcomeComponent;
